import {
  BaseQueryApi,
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/query";
import { logoutEverywhere } from "../../services/authLogoutService";
import { localStorageKeys } from "../../utils/localStorageItems";
import { RESPONSE_CODE } from "../network/constants";
import { API_SERVER_URL } from "../network/endpoints";

export const preparedAuthHeader = (token: string | null) => {
  return `Bearer ${token || ""}`;
};

export const appBaseQuery = {
  noAuth: fetchBaseQuery({
    baseUrl: API_SERVER_URL,
    prepareHeaders: async (headers) => headers,
  }),
  noAuthJson: fetchBaseQuery({
    baseUrl: API_SERVER_URL,
    prepareHeaders: async (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  withAuth: fetchBaseQuery({
    baseUrl: API_SERVER_URL,
    prepareHeaders: async (headers) => {
      headers.set(
        "Authorization",
        preparedAuthHeader(localStorage.getItem(localStorageKeys.accessToken))
      );
      return headers;
    },
  }),
  withAuthJson: fetchBaseQuery({
    baseUrl: API_SERVER_URL,
    prepareHeaders: async (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set(
        "Authorization",
        preparedAuthHeader(localStorage.getItem(localStorageKeys.accessToken))
      );
      return headers;
    },
  }),
};

let hasShownAuthError = false;

export const baseQueryWithAuthHandling = async (
  baseQuery: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError,
    {},
    FetchBaseQueryMeta
  >,
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: {}
) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === RESPONSE_CODE.UNAUTHORIZED) {
    if (!hasShownAuthError) {
      hasShownAuthError = true;
      // (9/18/2025) The toast below has been disabled,
      // instead we rely on `cause: "session-expire"` in `sideEffectLogOut` to show session expire toast
      // ------------------------------------------------------
      // toast.error("Session expired. Please log in again.");
    }

    // dispatch logout to clear state + localStorage
    logoutEverywhere({ redirect: true, cause: "session-expire" });
  }

  return result;
};

// call this when user logs back in to reset the flag
export const resetAuthErrorFlag = () => {
  hasShownAuthError = false;
};
